import { useState, useRef } from "react"
import emailjs from '@emailjs/browser'
import { LuMapPin, LuMail, LuSun, LuInstagram, LuFacebook, LuSend, LuCheckCircle2, LuAlertCircle } from "react-icons/lu";
import "../../styles/contact/contact.css"

//EMAILJS : service, modèle d'e-mail et clé publique utilisés pour envoyer le formulaire
const EMAILJS_SERVICE_ID = "service_hzuqqon";
const EMAILJS_TEMPLATE_ID = "template_t04ahse";
const EMAILJS_PUBLIC_KEY = "ZUxpgQcPrb62n7aPg";


function Contact() {

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [sendStatus, setSendStatus] = useState(null); // "success" | "error"

  const form = useRef()

  const isFormComplete = firstName !== "" && lastName !== "" && email !== "" && subject !== "" && message !== "";

  //ENVOI DU FORMULAIRE PAR EMAILJS (les attributs "name" des champs correspondent au modèle d'e-mail)
  const sendEmail = async (e) => {
    e.preventDefault();
    if (!isFormComplete) return;

    setIsSending(true);
    setSendStatus(null);
    try {
      await emailjs.sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, form.current, { publicKey: EMAILJS_PUBLIC_KEY });
      setFirstName("");
      setLastName("");
      setEmail("");
      setSubject("");
      setMessage("");
      setSendStatus("success");
    } catch (error) {
      setSendStatus("error");
    }
    setIsSending(false);
  };

  return (
    <main className="contact">

      {/* EN-TÊTE */}
      <header className="page-hero">
        <div className="wrap page-hero_content">
          <p className="page-hero_eyebrow">
            <span className="tricolor" aria-hidden="true"><span></span><span></span><span></span></span>
            Contact
          </p>
          <h1 className="page-hero_title">Nous contacter</h1>
          <p className="page-hero_text">Une question sur le club, les entraînements ou un partenariat ? Écrivez-nous via ce formulaire.</p>
        </div>
      </header>

      <div className="wrap contact_layout">

        {/* FORMULAIRE */}
        <section className="contact_form_card surface" aria-labelledby="contact-form-title">
          <h2 id="contact-form-title" className="title-lg contact_form_title">Formulaire de contact</h2>

          <form ref={form} onSubmit={sendEmail} className="contact_form">
            <div className="field_row">
              <div className="field">
                <label className="field_label" htmlFor="firstName">Prénom <span className="field_required">*</span></label>
                <input className="field_control" value={firstName} onChange={(e) => setFirstName(e.target.value)} type="text" id="firstName" name="sender_firstname" autoComplete="given-name" required />
              </div>
              <div className="field">
                <label className="field_label" htmlFor="lastName">Nom <span className="field_required">*</span></label>
                <input className="field_control" value={lastName} onChange={(e) => setLastName(e.target.value)} type="text" id="lastName" name="sender_lastname" autoComplete="family-name" required />
              </div>
            </div>

            <div className="field">
              <label className="field_label" htmlFor="email">E-mail <span className="field_required">*</span></label>
              <input className="field_control" value={email} onChange={(e) => setEmail(e.target.value)} type="email" id="email" name="sender_email" autoComplete="email" placeholder="adresse@email.com" required />
            </div>

            <div className="field">
              <label className="field_label" htmlFor="subject">Sujet <span className="field_required">*</span></label>
              <input className="field_control" value={subject} onChange={(e) => setSubject(e.target.value)} type="text" id="subject" name="subject" required />
            </div>

            <div className="field">
              <label className="field_label" htmlFor="message">Message <span className="field_required">*</span></label>
              <textarea className="field_control" value={message} onChange={(e) => setMessage(e.target.value)} id="message" name="message" rows={7} required />
            </div>

            {sendStatus === "success" && (
              <div className="msg msg--success contact_message" role="status">
                <LuCheckCircle2 aria-hidden="true" /> <p>Votre message a bien été envoyé. Merci !</p>
              </div>
            )}
            {sendStatus === "error" && (
              <div className="msg msg--error contact_message" role="alert">
                <LuAlertCircle aria-hidden="true" /> <p>Une erreur est survenue. Veuillez réessayer plus tard.</p>
              </div>
            )}

            <div className="contact_form_actions">
              <button type="submit" className="btn btn--primary btn--lg" disabled={isSending || !isFormComplete}>
                <LuSend aria-hidden="true" /> {isSending ? "Envoi en cours…" : "Envoyer"}
              </button>
            </div>
          </form>
        </section>

        {/* COORDONNÉES */}
        <aside className="contact_aside" aria-label="Autres moyens de nous contacter">
          <ul className="contact_infos">
            <li className="contact_info">
              <span className="icon-tile icon-tile--red" aria-hidden="true"><LuMapPin /></span>
              <div>
                <p className="contact_info_label">Siège social</p>
                <address className="contact_info_value">9 avenue Bordaberry<br />64500 Saint-Jean-de-Luz</address>
              </div>
            </li>
            <li className="contact_info">
              <span className="icon-tile icon-tile--green" aria-hidden="true"><LuMail /></span>
              <div>
                <p className="contact_info_label">Inscriptions et licences</p>
                <a className="contact_info_value" href="mailto:adhesion@vblc.fr">adhesion@vblc.fr</a>
              </div>
            </li>
            <li className="contact_info">
              <span className="icon-tile icon-tile--sand" aria-hidden="true"><LuSun /></span>
              <div>
                <p className="contact_info_label">Section beach</p>
                <a className="contact_info_value" href="mailto:vblcbeach@gmail.com">vblcbeach@gmail.com</a>
              </div>
            </li>
          </ul>

          <div className="contact_social">
            <p className="contact_info_label">Suivez-nous</p>
            <div className="contact_social_links">
              <a className="contact_social_link" href="https://www.instagram.com/vblc_volleyball/?hl=fr" target="_blank" rel="noreferrer">
                <LuInstagram aria-hidden="true" /> Instagram
              </a>
              <a className="contact_social_link" href="https://www.facebook.com/vblc64/" target="_blank" rel="noreferrer">
                <LuFacebook aria-hidden="true" /> Facebook
              </a>
            </div>
          </div>
        </aside>
      </div>
    </main>
  )
};

export default Contact;
